<template>
  <v-textarea
    v-model="currentText"
    class="display-field-text textarea text-wrap"
    density="compact"
    variant="plain"
    rows="1"
    hide-details
    auto-grow
    :bg-color="bgColor"
    :placeholder="placeholder"
    :disabled="!editing"
  />
</template>
<script>
export default {
  name: 'DisplayFieldTextarea',
  props: {
    value: {
      type: String,
      default: '',
    },
    editing: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
  },
  // This emit is functionally the same as 'input' but for the sake of removing test errors
  // It is referred to as update:modelValue here
  emits: ['update:modelValue'],
  computed: {
    bgColor() {
      return this.editing ? '#EBEBEB' : 'rgb(0,0,0,0)';
    },
    currentText: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal);
      },
    },
  },
};
</script>
<!--
The variables in :deep(textarea) are to hack Vuetify so the textarea is the right height:
Vuetify sets the height correctly except when the textarea is exactly one line high.
--v-input-control-height: The height Vuetify is trying to set for the textarea.
--clamp-toggle: 0 if the textarea is one line high, else 1.
--height-from-ctrl: 0 if textarea is one line high, else equal to --v-input-control-height.
--height-from-min: 0 if textarea is multiple lines high, else 15px (the height we want for one line).
-->
<style lang="scss" scoped>
  .textarea {
   & :deep(textarea)  {
      // text styling copied from the display-field-text class
      @extend .display-field-text;
      // other styling
      -webkit-mask-image: none !important;
      mask-image: none !important;
      padding: 1px 3px;
      overflow: hidden;
      margin-left: 2px;
      --height-from-ctrl: calc(max(0px, calc(var(--v-input-control-height) - 38px)) + (38 * var(--clamp-toggle)));
      --height-from-min: calc(((var(--clamp-toggle) - 1px) * -1) * 15);
      --clamp-toggle: clamp(0px, calc(var(--v-input-control-height) - 38px), 1px);
      min-height: calc(var(--height-from-ctrl) + var(--height-from-min));
    }
  & :deep(.v-field) {
    border-radius: 2px;
    opacity: 1;
  }
  & :deep(.v-field--disabled) {
    pointer-events: all;
  }
  & :deep(.v-field__input) {
    cursor: text;
  }
}
</style>
